import { render, staticRenderFns } from "./ViewInfiniceptOnboarding.vue?vue&type=template&id=63934793&scoped=true"
import script from "./ViewInfiniceptOnboarding.vue?vue&type=script&lang=js"
export * from "./ViewInfiniceptOnboarding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63934793",
  null
  
)

export default component.exports